import moment from 'moment';

export const findProp =(obj, key, out) => {
    let i,
        proto = Object.prototype,
        ts = proto.toString,
        hasOwn = proto.hasOwnProperty.bind(obj);

    if ('[object Array]' !== ts.call(out)) out = [];

    for (i in obj) {
        if (hasOwn(i)) {
            if (i === key && obj[i] !== '') {
                let tempObj = {[key]: obj[i]}
                out.some(el => {
                    el[key] ===  tempObj[key] && out.push(tempObj );
                    return '';
                }) 
            } else if ('[object Array]' === ts.call(obj[i]) || '[object Object]' === ts.call(obj[i])) {
                findProp(obj[i], key, out);
            }
        }
    }

    return out;
}

export const shuffleFisherYates = (array) => {
  let i = array.length;
  if (i > 2) {
    while (i--) {
      const ri = Math.floor(Math.random() * i);
      [array[i], array[ri]] = [array[ri], array[i]];
    }
  } else {
    array.sort(() => Math.random() - 0.5);
  }
  return array;
};

export const formatDate = (date) => {
  return moment.utc(date).format('MM/DD/YYYY');
}
